import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Checkbox, Col, Collapse, Row } from 'antd';
import * as actions from '../../actions/actionCreators/accountGOSTsAssignmentsActionCreators';
import { ClassificatorField, DateRangeField } from '../../atoms';
import { FormActions } from '../../components';
import {
  FORM_ACCOUNT_GOS_TS_ASSIGNMENTS_FILTER,
  tsAssignmentsFilter,
} from '../../constants/formAccountGOSTsAssignmentsFilter';
import {
  tradingMethod,
  tsAssignmentState,
} from '../../constants/classificators';
import PropTypesImmutable from 'react-immutable-proptypes';
import AutoCompleteAccountsIdField from '../../components/AutoCompleteAccountsField/AutoCompleteAccountsIdField';
import RffFields from '../../atoms/rff/RffFields';
import FormStateToRedux from '../FormStateToRedux';
import {
  updateFormState,
  formValueSelector,
} from '../../reducers/reactFinalFormReducer';

const { Panel } = Collapse;

export class AccountGOSTsAssignmentsFilter extends Component {
  isShowCompletedAssignments = false;

  static propTypes = {
    t: PropTypes.func.isRequired,
    filterValues: PropTypesImmutable.map,
    isAuctionsEnabled: PropTypes.bool.isRequired,
    searchAccountGOSTsAssignments: PropTypes.func.isRequired,
    updateFormState: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
  };

  componentDidMount() {
    const { initialValues, updateFormState } = this.props;
    if (initialValues) {
      updateFormState(FORM_ACCOUNT_GOS_TS_ASSIGNMENTS_FILTER, {
        values: initialValues,
      });
    }
  }

  onSubmit = () => {
    this.props.searchAccountGOSTsAssignments();
  };

  onClear = (form) => {
    const { initialValues, updateFormState } = this.props;
    this.isShowCompletedAssignments = false;
    form.restart(initialValues);
    updateFormState(FORM_ACCOUNT_GOS_TS_ASSIGNMENTS_FILTER, {
      values: initialValues,
    });
  };

  handleCheckboxChange = (event, form) => {
    const checked = event.target.checked;
    this.isShowCompletedAssignments = checked;
    form.change('isIncludeCompleted', checked);
    // Sync to Redux immediately before search reads it
    const currentValues = form.getState().values;
    this.props.updateFormState(FORM_ACCOUNT_GOS_TS_ASSIGNMENTS_FILTER, {
      values: { ...currentValues, isIncludeCompleted: checked },
    });
    this.props.searchAccountGOSTsAssignments();
  };

  render() {
    const { t, isAuctionsEnabled, initialValues } = this.props;

    const allowedTradingMethods = isAuctionsEnabled
      ? Object.values(tradingMethod)
      : tradingMethod.PRE_TRADING_AGREEMENT;

    return (
      <Form
        onSubmit={this.onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, form }) => (
          <React.Fragment>
            <Collapse>
              <Panel
                key="purchasing-agreement-filters"
                header={t('assignments.filter.panelTitle')}
              >
                <form onSubmit={handleSubmit}>
                  <FormStateToRedux
                    form={FORM_ACCOUNT_GOS_TS_ASSIGNMENTS_FILTER}
                  />
                  <Row gutter={24}>
                    <Col span={8}>
                      <Field
                        name={tsAssignmentsFilter.STATE}
                        component={ClassificatorField}
                        classificatorType={
                          ClassificatorField.types.tsAssignmentState
                        }
                        allowed={[
                          tsAssignmentState.CREATED,
                          tsAssignmentState.COMPLETED,
                        ]}
                        label={t('assignments.filter.state')}
                        hasFeedback={false}
                      />
                    </Col>
                    <Col span={8}>
                      <Field
                        name={tsAssignmentsFilter.TYPE}
                        component={ClassificatorField}
                        classificatorType={
                          ClassificatorField.types.tsAssignmentType
                        }
                        label={t('assignments.filter.type')}
                        hasFeedback={false}
                      />
                    </Col>
                    <Col span={8}>
                      <Field
                        name={tsAssignmentsFilter.TRADING_METHOD}
                        component={ClassificatorField}
                        classificatorType={
                          ClassificatorField.types.tradingMethod
                        }
                        label={t('assignments.filter.tradingMethod')}
                        hasFeedback={false}
                        allowed={allowedTradingMethods}
                      />
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={8}>
                      <Field
                        name={tsAssignmentsFilter.COUNTERPARTY_ID}
                        component={AutoCompleteAccountsIdField}
                        label={t('assignments.filter.counterparty')}
                        hasFeedback={false}
                      />
                    </Col>
                    <Col span={8}>
                      <RffFields
                        names={[
                          tsAssignmentsFilter.DUE_DATE_START,
                          tsAssignmentsFilter.DUE_DATE_END,
                        ]}
                        component={DateRangeField}
                        allowClear={false}
                        hasFeedback={false}
                        label={t('assignments.filter.dueDate')}
                        placeholder={[
                          t('assignments.filter.dateFromPlaceholder'),
                          t('assignments.filter.dateToPlaceholder'),
                        ]}
                        useTime={false}
                      />
                    </Col>
                  </Row>
                  <FormActions>
                    <Button onClick={() => this.onClear(form)}>
                      {t('assignments.filter.clearBtn')}
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      onClick={() => {
                        this.isShowCompletedAssignments = true;
                        form.change('isIncludeCompleted', true);
                      }}
                    >
                      {t('assignments.filter.submitBtn')}
                    </Button>
                  </FormActions>
                </form>
              </Panel>
            </Collapse>

            <FormActions>
              <div
                style={{
                  float: 'left',
                  paddingBottom: '15px',
                }}
              >
                <Checkbox
                  onChange={(event) => this.handleCheckboxChange(event, form)}
                  checked={this.isShowCompletedAssignments}
                >
                  {t('assignments.filter.showCompletedAssignments')}
                </Checkbox>
              </div>
            </FormActions>
          </React.Fragment>
        )}
      />
    );
  }
}

const getValues = formValueSelector(FORM_ACCOUNT_GOS_TS_ASSIGNMENTS_FILTER);

const mapStateToProps = (state) => ({
  filterValues: getValues(state),
});

const mapDispatchToProps = {
  searchAccountGOSTsAssignments: actions.searchAccountGOSTsAssignments,
  updateFormState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountGOSTsAssignmentsFilter);
